var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 226 445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40294 366.029L39.2841 444.345L44.2832 359.179L5.40294 366.029ZM54.281 355.476L112.786 417.499L88.3473 335.851L54.281 355.476ZM96.6787 329.001L172.958 367.325L122.044 298.822L96.6787 329.001ZM127.227 289.38L212.023 299.193L140.743 252.351L127.227 289.38ZM142.595 202.547V241.983L225.539 222.358L142.595 202.547ZM127.227 154.965L140.743 191.994L212.023 145.153L127.227 154.965ZM121.858 145.523L172.773 77.0199L96.4936 115.345L121.858 145.523ZM88.3473 108.494L112.786 26.8459L54.281 88.869L88.3473 108.494ZM44.2832 85.1662L39.2841 0L5.40294 78.3158L44.2832 85.1662ZM0.0337219 102.57L0.0337219 341.776C66.1301 341.776 119.637 288.269 119.637 222.173C119.637 156.076 66.1301 102.57 0.0337219 102.57Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSun);
export default __webpack_public_path__ + "static/media/WhiteSun.fde45feace9239fb1cab702d5483c499.svg";
export { ForwardRef as ReactComponent };